import React from 'react'

import Link from '@Pure/Link'

import { mergeDeep } from '@root/utility'

export let form =
{
	model: 'place',
	name: 'place',

	form_title: 'Lieu',

	fields:
	{
		'name':
		{
			label: 'Nom'
		},

		'address[line_1]':
		{
			label: 'Adresse'
		},

		'address[line_2]':
		{
			label: 'Complément d\'adresse'
		},

		'address[zip_code]':
		{
			label: 'Code postal'
		},

		'address[city]':
		{
			label: 'Ville'
		},

		'description':
		{
			label: 'Description',
			type: 'editor',
			images: false
		},

		'images':
		{
			type: 'image',
			label: 'Images',
			multiple: true
		},

		'infos[phone]':
		{
			label: 'Téléphone'
		},

		'infos[email]':
		{
			label: 'E-mail'
		},

		'infos[website]':
		{
			label: 'Site web'
		},

		'infos[facebook]':
		{
			label: 'Facebook'
		},

		'infos[instagram]':
		{
			label: 'Instagram'
		},

		'infos[twitter]':
		{
			label: 'Twitter'
		},

		place_themes:
		{
			label: 'Thème principal',
			reference:
			{
				model: 'PlaceTheme'.toLowerCase(),
				referenced_field:
				{
					name: 'label',
					type: 'text'
				}
			},
			autocomplete: 'label'
		},

		'highlighted':
		{
			label: 'À ne pas rater (accueil)',
			type: 'checkbox',
			column: true
		}
	},

	create_label: 'Créer ce lieu',

	collapses:
	[
		{
			type: 'collapse',
			title: 'Adresse',

			elements:
			[
				'name',
				'address[line_1]',
				'address[line_2]',
				'address[zip_code]',
				'address[city]'
			]
		},

		{
			type: 'collapse',
			title: 'Contact',

			elements:
			[
				'infos[phone]',
				'infos[email]'
			]
		},

		{
			type: 'collapse',
			title: 'Media',

			elements:
			[
				'infos[website]',
				'infos[facebook]',
				'infos[instagram]',
				'infos[twitter]',
				'description',
				'images'
			]
		}
	],

	views:
	[
		{
			title: 'Thème principal',
			search_label: 'Chercher un thème principal',
			source_field: 'place_themes',
			add_label: 'Ajouter ce thème',
			grid_class: 'o-grid-4',
			render: function (data, key)
			{
				let output =
				(
					<div className="o-grid__item" key={ key }>

						<div className="c-view-item">
							<div className="c-view-item__infos">
								<div className="c-view-item__data">
									{ data.model_data.label }
								</div>
							</div>
						</div>

					</div>
				);

				return output;
			},
			search:
			{
				display_fields: ['label']
			}
		}
	],

	get__deleteModalText: function (form_data)
	{
		var output =
		(
			<span>
				<p>
					Êtes vous sûr de vouloir supprimer ce lieu&nbsp;?
				</p>

				<div className="u-center">

					<div className="name-in-modal">

						{ form_data['place[name]'] }

					</div>

				</div>
			</span>
		);

		return output;
	},

	get__createdMessage: function (place)
	{
		var output =
		(
			<div className="c-message c-message--green">
				<div className="c-message__content">
					Le nouveau lieu <strong> { place.name } </strong> a été créé.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ '/configuration/lieux/' + place.id }>
						Voir le lieu
					</Link>
				</div>
			</div>
		);

		return output;
	}
}

export let list =
{
	model         : 'place',
	title         : 'Liste des lieux',
	link          : '/configuration/lieux',
	creation_link : '/configuration/nouveau-lieu',
	creation_label: 'Nouveau lieu',
	header_map    :
	{
		'Nom'  : 'name',
		'Ville': 'address.city'
	},
	row_link_base : '/configuration/lieux/',
	searched_prop : ['name', 'address.city']
}

let config = mergeDeep({ }, form);

config = mergeDeep(config, list);

export default config